import { Buffer } from 'buffer';
import { TenantTsType } from '../constants/tenantTs';

export const getTsTypeByIdentifier = ({
  identifier,
  type,
}: {
  identifier?: string;
  type?: 'flight' | 'hotel';
}): TenantTsType | undefined => {
  if (!identifier) return undefined;
  try {
    const decoded = JSON.parse(
      Buffer.from(identifier, 'base64').toString('utf8')
    );
    const tsString = String(decoded?.ts);
    return (Object.values(TenantTsType) as string[]).includes(tsString)
      ? (tsString as TenantTsType)
      : undefined;
  } catch {
    return undefined;
  }
};
